import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  roleId: '',
};

export const createPermission = createSlice({
  name: 'createPermission',
  initialState,
  reducers: {
    updatePermissionInfo: (state, action) => {
      state.roleId = action.payload;
    },
    clearPermissionInfo: (state) => {
      state.roleId = initialState.roleId;
    },
  },
});

export const permissionDetailSelector = (state) =>
  state.createPermission.roleId;
export const { updatePermissionInfo, clearPermissionInfo } =
  createPermission.actions;

export const createPermissionReducer = createPermission.reducer;
export const createPermissionReducerName = createPermission.name;

export default createPermission.reducer;
